var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "notification-reminder-activity" },
    [
      _c("CompassObject", {
        attrs: { size: "small", type: "object", object: _vm.object }
      }),
      _vm._v(" "),
      _c("div", { staticClass: "notification-reminder-activity__content" }, [
        _c("p", { staticClass: "typographies-paragraph-medium-regular" }, [
          _vm._v("\n            " + _vm._s(_vm.text.title) + "\n            "),
          !!_vm.text.relatedName
            ? _c(
                "span",
                { staticClass: "typographies-paragraph-medium-bold" },
                [
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.text.relatedName) +
                      "\n            "
                  )
                ]
              )
            : _vm._e(),
          _vm._v(
            "\n            " + _vm._s(_vm.text.dueDatePrefix) + "\n            "
          ),
          _c("span", { staticClass: "typographies-paragraph-medium-bold" }, [
            _vm._v(
              "\n                " +
                _vm._s(_vm._f("lowerCase")(_vm.text.dateHumanized)) +
                "\n            "
            )
          ])
        ]),
        _vm._v(" "),
        _vm.context === _vm.NOTIFICATION_CONTEXT.NOTIFICATION_CENTER
          ? _c(
              "span",
              {
                staticClass:
                  "notification-reminder-activity__content-caption typographies-paragraph-small-regular"
              },
              [_vm._v("\n            " + _vm._s(_vm.caption) + "\n        ")]
            )
          : _vm._e()
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }